export default "__VITE_ASSET__DUjCp0_X__"